var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEffects(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.413 8.937a1.594 1.594 0 11-3.189 0 1.594 1.594 0 013.19 0zm6.471 0a1.594 1.594 0 11-3.188 0 1.594 1.594 0 013.188 0zm-.995 12.281h-7.692a.956.956 0 01-.926-1.206l.778-4.145a1.058 1.058 0 011.042-.778h5.911a1.058 1.058 0 011.043.778l.777 4.145a.954.954 0 01-.933 1.206z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.631 4.41H8.478a1.851 1.851 0 00-1.851 1.812v15.556a1.851 1.851 0 001.85 1.85h11.154a1.851 1.851 0 001.851-1.85V6.222a1.851 1.851 0 00-1.85-1.812zm.825 17.049a1.034 1.034 0 01-1.011 1.034H8.68a1.034 1.034 0 01-1.034-1.034V6.54A1.034 1.034 0 018.68 5.507h10.765a1.034 1.034 0 011.01 1.034V21.46z",
    clipRule: "evenodd"
  })));
}

export default SvgEffects;